import type { AltDefaultBackgroundCmsMetaKeyOptionValueOption } from '../cms/content/ko/CmsContentContract';

export interface AltDefaultBackgroundInput {
    key: keyof typeof AltDefaultBackgroundCmsMetaKeyOptionValueOption;
    label: string;
}

export class AltDefaultBackground {
    /**
     * Key of the alternative default background to be displayed.
     */
    public key: string;

    /**
     * Label that will be displayed to the end-user
     */
    public label: string;

    /**
     * Optional URL (ex. when background is a background image)
     */
    public url?: string;

    public constructor(input: AltDefaultBackgroundInput) {
        this.key = input.key;
        this.label = input.label;
    }

    public withUrl(url: string): AltDefaultBackground {
        this.url = url;
        return this;
    }
}
